import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/th";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { EARLIEST_EXPENSE_MONTH } from "./constants";

const PICKER_LOCALE = "th";
const MONTH_VIEWS = ["year", "month"] as const;
const MONTH_DISPLAY_FORMAT = "MMMM YYYY";
const MONTH_PICKER_WIDTH = 220;
const EARLIEST_MONTH = dayjs(EARLIEST_EXPENSE_MONTH);
const MONTH_PARAM_PATTERN = /^\d{4}-\d{2}$/;
const MONTH_PICKER_SLOT_PROPS = {
  textField: { size: "small", sx: { width: MONTH_PICKER_WIDTH } },
} as const;

/** A hand-edited query string must not seed the picker with a month that is not one. */
export const parseMonthParam = (value: string | null): Dayjs | null => {
  if (!value || !MONTH_PARAM_PATTERN.test(value)) return null;
  const parsed = dayjs(`${value}-01`);
  return parsed.isValid() ? parsed : null;
};

interface ExpenseMonthPickerProps {
  value: Dayjs;
  onChange: (value: Dayjs | null) => void;
  /** S6 sets next month's targets, so it may pick a future month. */
  allowFuture?: boolean;
}

/** The รับจ่าย month picker (S2 list, S4): Thai month names, up to the current month. */
export default function ExpenseMonthPicker({ value, onChange, allowFuture = false }: Readonly<ExpenseMonthPickerProps>) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={PICKER_LOCALE}>
      <DatePicker
        views={MONTH_VIEWS}
        openTo="month"
        value={value}
        onChange={onChange}
        format={MONTH_DISPLAY_FORMAT}
        minDate={EARLIEST_MONTH}
        disableFuture={!allowFuture}
        slotProps={MONTH_PICKER_SLOT_PROPS}
      />
    </LocalizationProvider>
  );
}
